import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import { Autocomplete, Button, Grid, IconButton } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import "./mainten.scss";
import { useNavigate, useParams } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useDispatch } from "react-redux";
import {
  addNewMaintenance,
  editMaintenance,
  fetchInventory,
  fetchMaintenanceById,
  fetchVehicle,
} from "../../store/slices/thunk";
import { toast, ToastContainer } from "react-toastify";
import { AddCircle, Delete } from "@mui/icons-material";
import { FaPlusSquare } from "react-icons/fa";
import Spinner from "react-bootstrap/esm/Spinner";

const Maintenanceadd = () => {
  const navigate = useNavigate();
  const [allParts, setAllParts] = useState([]);
  const [addMaintenance, setAddMaintenance] = useState({
    vehicle: {
      vehicleId: "",
      vehicleName: "",
    },
    maintenanceStartDate: 0,
    maintenanceEndDate: 0,
    serviceDetails: "",
    totalCost: 0,
    vendorName: "",
    part: [
      {
        partId: "",
        partName: "",
        quantity: 0,
      },
    ],
    quantity: 0,
    maintenanceStatus: "",
    _id: "",
  });

  const { id } = useParams<any>();
  const [isEdit, setIsEdit] = useState(false);
  const dispatch: any = useDispatch();
  const [getAllVehicle, setAllVehicle] = useState([]);
  const [searchVehicle, setSearchVehicle] = React.useState("");
  const [searchPartInventory, setSearchPartInventory] = React.useState("");
  const [totalCount, setTotalCount] = useState(0);
  const DEBOUNCE_DELAY = 500;
  const ITEMS_PER_PAGE = 10;
  const pageCount = Math.ceil(totalCount / ITEMS_PER_PAGE);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        setIsEdit(true);
        const response: any = await dispatch(fetchMaintenanceById(id));

        const {
          vehicle,
          maintenanceStartDate,
          maintenanceEndDate,
          serviceDetails,
          totalCost,
          vendorName,
          part,
          quantity,
          maintenanceStatus,
          _id,
        } = response.data;

        setAddMaintenance({
          vehicle: {
            vehicleId: vehicle?.vehicleId || "",
            vehicleName: vehicle?.vehicleName || "",
          },
          maintenanceStartDate: maintenanceStartDate || 0,
          maintenanceEndDate: maintenanceEndDate || 0,
          serviceDetails: serviceDetails || "",
          totalCost: totalCost || 0,
          vendorName: vendorName || "",
          part: part?.length
            ? part
            : [
                {
                  partId: "",
                  partName: "",
                  quantity: 0,
                },
              ],
          quantity: quantity || 0,
          maintenanceStatus: maintenanceStatus || "",
          _id: _id || "",
        });

        console.log("Fetched Maintenance:", response.data);
      } else {
        setIsEdit(false);
        setAddMaintenance({
          vehicle: {
            vehicleId: "",
            vehicleName: "",
          },
          maintenanceStartDate: 0,
          maintenanceEndDate: 0,
          serviceDetails: "",
          totalCost: 0,
          vendorName: "",
          part: [
            {
              partId: "",
              partName: "",
              quantity: 0,
            },
          ],
          quantity: 0,
          maintenanceStatus: "",
          _id: "",
        });
      }
    };

    fetchData();
  }, [id, navigate, dispatch]);

  // useEffect(() => {
  //   const getVehicle = async () => {
  //     const response = await dispatch(fetchVehicle(1, 99999999, ""));
  //     if (response && response.data.totalCount > 0 && response.isSuccess) {
  //       setAllVehicle(response.data.data);
  //     } else {
  //       setAllVehicle([]);
  //     }
  //     console.log(getAllVehicle);
  //   };

  //   getVehicle();
  // }, [dispatch]);

  useEffect(() => {
    const handler = setTimeout(async () => {
      const response = await dispatch(fetchVehicle(1, 10, searchVehicle));
      if (
        response &&
        response?.data &&
        response?.data?.data &&
        response?.data?.data?.length &&
        response?.isSuccess
      ) {
        setAllVehicle(response?.data?.data);
        setTotalCount(response?.data?.totalCount);
      } else {
        setAllVehicle([]);
        setTotalCount(0);
      }
    }, DEBOUNCE_DELAY);
    return () => {
      clearTimeout(handler);
    };
  }, [searchVehicle, dispatch]);

  // useEffect(() => {
  //   const getAllPartInventory = async () => {
  //     const response: any = await dispatch(fetchInventory(1, 9999, ""));
  //     if (response && response.data.data.length > 0  && response.isSuccess) {
  //       setAllParts(response.data.data);
  //     } else {
  //       setAllParts([]);
  //     }
  //     console.log(allParts);
  //   };

  //   getAllPartInventory();
  // }, [dispatch]);

  useEffect(() => {
    const handler = setTimeout(async () => {
      const response = await dispatch(
        fetchInventory(1, 10, searchPartInventory)
      );
      if (
        response &&
        response?.data &&
        response?.data?.data &&
        response?.data?.data?.length &&
        response?.isSuccess
      ) {
        setAllParts(response?.data?.data);
        setTotalCount(response?.data?.totalCount);
      } else {
        setAllParts([]);
        setTotalCount(0);
      }
    }, DEBOUNCE_DELAY);
    return () => {
      clearTimeout(handler);
    };
  }, [searchPartInventory, dispatch]);

  const handleChangeForVehicle = (e: any) => {
    const { value } = e.target;
    if (!value) {
      // Jab user ne selection clear kar diya
      setAddMaintenance({
        ...addMaintenance,
        vehicle: {
          vehicleId: "",
          vehicleName: "",
        },
      });
      return;
    }

    const selectedVehicle: any = getAllVehicle.find(
      (vehicle: any) => vehicle._id === value
    );

    if (selectedVehicle) {
      setAddMaintenance({
        ...addMaintenance,
        vehicle: {
          vehicleId: selectedVehicle._id,
          vehicleName: selectedVehicle.vehicleName,
        },
      });
    }
  };
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setAddMaintenance((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    console.log("Sending:", addMaintenance);
    setLoading(true);

    try {
      const {
        vehicle,
        maintenanceStartDate,
        maintenanceEndDate,
        serviceDetails,
        totalCost,
        vendorName,
        part,
        maintenanceStatus,
      } = addMaintenance;

      // Basic validation check
      if (
        vehicle.vehicleId === "" ||
        vehicle.vehicleName === "" ||
        !maintenanceStartDate ||
        !maintenanceEndDate ||
        serviceDetails.trim() === "" ||
        totalCost === 0 ||
        vendorName.trim() === "" ||
        part.length === 0 ||
        maintenanceStatus.trim() === ""
      ) {
        toast.error("Fill all required fields!");
        return;
      }

      if (isEdit) {
        const res: any = await dispatch(editMaintenance(addMaintenance));
        if (res.data && res.isSuccess) {
          console.log("Success:", res);
          toast.success("Maintenance Updated!");
          navigate("/maintenance-list");
        } else {
          toast.error("Maintenance Not Updated!");
        }
      } else {
        const res: any = await dispatch(addNewMaintenance(addMaintenance));
        if (res.data && res.isSuccess) {
          console.log("Success:", res);
          toast.success("Maintenance Added!");
          navigate("/maintenance-list");
        } else {
          toast.error("Maintenance Not Added!");
        }
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };
  const handleAddPart = () => {
    setAddMaintenance((prev) => ({
      ...prev,
      part: [
        ...prev.part,
        { partId: "", partName: "", quantity: 0 }, // Default empty part
      ],
    }));
  };

  const handlePartChange = (index: number, partId: string) => {
    const selectedPart: any = allParts.find((part: any) => part._id === partId); // Find selected part by ID
    const updatedParts = addMaintenance.part.map((part, i) =>
      i === index
        ? {
            ...part,
            partId,
            partName: selectedPart ? selectedPart.name : "", // Update partName based on partId
          }
        : part
    );
    setAddMaintenance((prev) => ({
      ...prev,
      part: updatedParts,
    }));
  };

  const handleRemovePart = (index: number) => {
    const updatedParts = addMaintenance.part.filter((_, i) => i !== index);
    setAddMaintenance((prev) => ({
      ...prev,
      part: updatedParts,
    }));
  };
  const navigateToMaintenanceList = () => {
    navigate("/maintenance-list");
  };
const inputStyle = {
  height: "48px",
  width: "100%",
  borderRadius: "10px",
  margin: 0,
  "& .MuiInputBase-root": {
    height: "48px",
    borderRadius: "10px",
  },
  "& .MuiSelect-select": {
    height: "48px",
    display: "flex",
    alignItems: "center",
  },
};

  const handleQuantityChange = (index: number, value: number) => {
    const updatedParts = addMaintenance.part.map((part, i) =>
      i === index ? { ...part, quantity: value } : part
    );
    setAddMaintenance((prev) => ({
      ...prev,
      part: updatedParts,
    }));
  };

  return (
    <div>
      <ToastContainer />
      <div className="main-content">
  <div className="head d-flex justify-content-lg-between justify-content-start flex-column flex-lg-row flex-wrap">
    <div className="d-flex flex-column">
      <h2 className="fw-bold fs-4" style={{ color: "#1F2937" }}>
        {isEdit ? "Edit Maintenance" : "Add New Maintenance"}
      </h2>
      <p style={{ color: "#4B5563" }}>Fill in the driver information below</p>
    </div>
    <button
      type="button"
      onClick={navigateToMaintenanceList}
      className="btn rounded-2"
      style={{ backgroundColor: "transparent", width: "fit-content" }}
    >
      <KeyboardBackspaceIcon />
      <span style={{ marginLeft: "10px" }}>Back To List</span>
    </button>
  </div>

  <div className="boX" style={{ borderRadius: "20px" }}>
    <div className="container mt-3">
      <div className="row">
        {/* Left column */}
        <div className="col-md-6">
          <div className="row">
            <div className="col-md-12 mt-3">
              <h6 className="d-block mb-2" style={{ fontSize: "0.875rem", fontWeight: 700, color: "#374151" }}>
                Select Vehicle
              </h6>
              <Box sx={{ minWidth: 120 }}>
                <Autocomplete
                  options={getAllVehicle}
                  getOptionLabel={(option: any) => option.vehicleName}
                  value={
                    getAllVehicle.find((v: any) => v._id === addMaintenance.vehicle?.vehicleId) || null
                  }
                  onInputChange={(event, newInputValue) => setSearchVehicle(newInputValue)}
                  onChange={(event, newValue: any) => {
                    handleChangeForVehicle({ target: { value: newValue ? newValue._id : "" } });
                  }}
                  clearOnEscape
                  ListboxProps={{
                    sx: {
                      backgroundColor: "#fff",
                      color: "#000",
                      "& .MuiAutocomplete-option": { color: "#000" },
                    },
                  }}
                  renderInput={(params) => <TextField {...params} label="Search or Select Vehicle" sx={inputStyle} />}
                />
              </Box>
            </div>

            <div className="col-md-12 mt-3">
              <h6 className="d-block mb-2" style={{ fontSize: "0.875rem", fontWeight: 700, color: "#374151" }}>
                Maintenance Start Date
              </h6>
              <TextField
                type="date"
                name="maintenanceStartDate"
                value={
                  addMaintenance.maintenanceStartDate
                    ? new Date(addMaintenance.maintenanceStartDate).toISOString().split("T")[0]
                    : ""
                }
                onChange={(e) =>
                  setAddMaintenance({
                    ...addMaintenance,
                    maintenanceStartDate: new Date(e.target.value).getTime(),
                  })
                }
                sx={inputStyle}
              />
            </div>

            <div className="col-md-12 mt-3">
              <h6 className="d-block mb-2" style={{ fontSize: "0.875rem", fontWeight: 700, color: "#374151" }}>
                Total Cost
              </h6>
              <TextField
                id="outlined-basic"
                label="Total Cost"
                type="number"
                name="totalCost"
                value={addMaintenance.totalCost}
                onChange={(e) => handleChange(e)}
                variant="outlined"
                sx={inputStyle}
              />
            </div>
          </div>
        </div>

        {/* Right column */}
        <div className="col-md-6">
          <div className="row">
            <div className="col-md-12 mt-3">
              <h6 className="d-block mb-2" style={{ fontSize: "0.875rem", fontWeight: 700, color: "#374151" }}>
                Maintenance End Date
              </h6>
              <TextField
                type="date"
                name="maintenanceEndDate"
                value={
                  addMaintenance.maintenanceEndDate
                    ? new Date(addMaintenance.maintenanceEndDate).toISOString().split("T")[0]
                    : ""
                }
                onChange={(e) =>
                  setAddMaintenance({
                    ...addMaintenance,
                    maintenanceEndDate: new Date(e.target.value).getTime(),
                  })
                }
                sx={inputStyle}
              />
            </div>

            <div className="col-md-12 mt-3">
              <h6 className="d-block mb-2" style={{ fontSize: "0.875rem", fontWeight: 700, color: "#374151" }}>
                Vendor Name
              </h6>
              <TextField
                id="outlined-basic"
                type="text"
                name="vendorName"
                value={addMaintenance.vendorName}
                onChange={(e) => handleChange(e)}
                label="Vendor Name"
                variant="outlined"
                sx={inputStyle}
              />
            </div>

            <div className="col-md-12 mt-3">
              <h6 className="d-block mb-2" style={{ fontSize: "0.875rem", fontWeight: 700, color: "#374151" }}>
                Maintenance Status
              </h6>
              <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth sx={inputStyle}>
                  <InputLabel id="demo-simple-select-label">Maintenance Status</InputLabel>
                  <Select
                    onChange={(e) => handleChange(e)}
                    labelId="demo-simple-select-label"
                    value={addMaintenance.maintenanceStatus}
                    name="maintenanceStatus"
                    label="select Traccar Device ID"
                  >
                    <MenuItem value="planned" sx={{ color: "#000" }}>Planned</MenuItem>
                    <MenuItem value="inProgress" sx={{ color: "#000" }}>InProgress</MenuItem>
                    <MenuItem value="completed" sx={{ color: "#000" }}>Completed</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>
          </div>
        </div>

        {/* Service Details */}
        <div className="col-md-12 mt-3">
          <div className="gps">
            <h6 className="d-block mb-2" style={{ fontSize: "0.875rem", fontWeight: 700, color: "#374151" }}>
              Service Details
            </h6>
            <textarea
  name="serviceDetails"
  value={addMaintenance.serviceDetails}
  onChange={handleChange}
  placeholder="Enter details here"
  rows={4}
  style={{
    width: "100%",
    borderRadius: "10px",
    border: "1px solid #ccc",
    padding: "10px",
    fontSize: "14px",
    resize: "vertical", // user apni marzi se height adjust kar sake
  }}
/>

          </div>
        </div>
      </div>

      {/* Parts section */}
      {addMaintenance.part.map((part, index) => (
        <div className="row mt-3" key={index}>
          <div className="col-md-12">
            <Grid container spacing={2} alignItems="center">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <h6 className="d-block mb-2" style={{ fontSize: "0.875rem", fontWeight: 700, color: "#374151" }}>
                      Parts name
                    </h6>
                    <Box>
                      <Autocomplete
                        options={allParts}
                        getOptionLabel={(option: any) => option.name}
                        value={part.partId ? allParts.find((p: any) => p._id === part.partId) : null}
                        onInputChange={(event, newInputValue) => setSearchPartInventory(newInputValue)}
                        onChange={(event, newValue: any) =>
                          handlePartChange(index, newValue ? newValue._id : "")
                        }
                        clearOnEscape
                        ListboxProps={{
                          sx: {
                            backgroundColor: "#fff",
                            color: "#000",
                            "& .MuiAutocomplete-option": { color: "#000" },
                          },
                        }}
                        renderInput={(params) => <TextField {...params} label="Search or Select Part" sx={inputStyle} />}
                      />
                    </Box>
                  </div>

                  <div className="col-md-6">
                    <div className="qty d-flex align-items-center">
                      <h6 className="d-block mb-2" style={{ fontSize: "0.875rem", fontWeight: 700, color: "#374151" }}>
                        Qty
                      </h6>
                      {addMaintenance.part.length > 1 && (
                        <Box>
                          <IconButton onClick={() => handleRemovePart(index)}>
                            <Delete />
                          </IconButton>
                        </Box>
                      )}
                      <Box>
                        <IconButton color="primary" onClick={handleAddPart}>
                          <FaPlusSquare />
                        </IconButton>
                      </Box>
                    </div>
                    <FormControl fullWidth sx={inputStyle}>
                      <InputLabel id={`quantity-label-${index}`}>Quantity</InputLabel>
                      <Select
                        fullWidth
                        labelId={`quantity-label-${index}`}
                        value={part.quantity}
                        onChange={(e) => handleQuantityChange(index, Number(e.target.value))}
                        label="quantity"
                      >
                        {[...Array(10)].map((_, i) => (
                          <MenuItem key={i + 1} value={i + 1} sx={{ color: "#000" }}>
                            {i + 1}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </div>
            </Grid>
          </div>
        </div>
      ))}
    </div>

    {/* Submit Button */}
    <div className="container mb-3">
      <div className="row">
             <div className="col-md-12 d-flex justify-content-end">
          <div className="mt-4 aDD" style={{width:"fit-content"}}> 
            <Button
              onClick={handleSubmit}
              disabled={loading}
              style={{
                textTransform: "none",
                width: "100%",
                background: "#4285F4",
                fontWeight: "600",
              }}
            >
              {loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  {isEdit ? "Edit..." : "Add..."}
                </>
              ) : isEdit ? (
                "Edit Maintenance"
              ) : (
                "Add Maintenance"
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
    </div>
  );
};

export default Maintenanceadd;
